import { Injectable } from '@angular/core';

import { AbstractAsyncTaskReport } from './abstract-async-task.report';
import { ITask } from './async-task-constants';


@Injectable({
    providedIn: 'root'
  })
export class ContactDirectRelationsImportReport extends AbstractAsyncTaskReport {

    public generate(task: ITask): string {
        if (task.status === 'success') {
          return `<div>Import des contacts sur site réussi.</div>`;

        } else {
          let htmlDetail = `<div>Échec de l'import des contacts sur site.<br></div>`;
          htmlDetail += this.formatOnlyStructureAndContentImportError(task.detail);
          return htmlDetail;
        }
      }
}
